<template>
		<div class="FieldCheckExtendedItem" :class="{'is-selected': field.value}">
			<div class="FieldCheckExtendedItem-title">{{field.label}}</div>
			<StyledText :text="field.text"/>
			<div class="FieldCheckExtendedItem-image" v-if="field.image">
				<img :src="field.image.thumbnail">
			</div>
			<label>
				<input type="checkbox" v-model="field.value" :disabled="field.disabled">
			</label>
		</div>
</template>

<script>
	export default {
		props: {
			field: Object
		}
	}
</script>

<style lang="scss" scoped>
	.FieldCheckExtendedItem {
		border: 2px solid var(--colorInputBorder);
		position: relative;
		padding: 5em 2em 2em;
		display: flex;
		flex-direction: column;
		transition: all .25s ease-in-out;

		&.is-selected {
			border-color: var(--colorBrand);
		}

		label {
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
			display: flex;
			justify-content: center;
			padding-top: 2.2em;
			cursor: pointer;
		}

		&-title {
			text-align: center;
			font-weight: 700;
			font-size: var(--textMd);
			margin-bottom: 1.7em;
			color: var(--colorBrandDark);
		}

		&-list {
			margin-bottom: 2em;
		}

		&-note {
			font-weight: 700;
			font-size: var(--textSm);
			line-height: 1.5;
		}

		&-image {
			margin: auto -2em -2em;

			img {
				width: 100%;
				display: block;
			}
		}

		input[type=checkbox] {
			-moz-appearance: none;
			-webkit-appearance: none;
			appearance: none;
			border: 2px solid var(--colorBrand);
			width: 1.3em;
			height: 1.3em;
			border-radius: 3px;
			background: transparent;
			transition: all .25s ease-in-out;
			outline: none;

			&:before {
				content: ' ';
				display: block;
				transform: rotate(-45deg);
				width: .5em;
				height: .2em;
				border-left: .23em solid #fff;
				border-bottom: .23em solid #fff;
				margin: .13em .1em;
				transition: all .25s ease-in-out;
				opacity: 0;
			}

			&:checked {
				background: var(--colorBrand);

				&:before {
					opacity: 1;
				}
			}
		}
	}
</style>